import { Pipe, PipeTransform } from "@angular/core";
import NamedContact from "../../models/named-contact";

@Pipe({
  name: "printName",
})
export class NamedContactPipe implements PipeTransform {
  transform(value: NamedContact, ...args: any[]): any {
    if (!value) return;
    let name = "";

    if (value.prefix && value.prefix != "Other") {
      name += value.prefix;
    }

    if (value.firstName) {
      name += " " + value.firstName;
    }

    if (value.lastName) {
      name += " " + value.lastName;
    }

    if (value.suffix && value.suffix != "Other" && value.suffix != "None") {
      name += " " + value.suffix;
    }

    return name;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/named-contact.ts